<form [formGroup]="parentForm" (ngSubmit)="saveGuardian()" class="max-w-5xl space-y-6">
  <input formControlName="client_id" type="hidden">
  <input formControlName="user_id" type="hidden">

    <div class="space-y-4">
    <div class="grid grid-cols-[220px_1fr] items-center gap-4">
      <label class="text-sm font-medium text-slate-700">Name</label>
      <div>
        <input formControlName="name" type="text" max="100" class="input input-bordered w-full" placeholder="Name">
        @if (parentForm.get('name')?.errors && parentForm.get('name')?.touched) {
          <div class="text-error text-xs mt-1">
            {{ getFieldError(parentForm.get('name'), 'name') }}
          </div>
        }
      </div>
    </div>

    <div class="grid grid-cols-[220px_1fr] items-center gap-4">
      <label class="text-sm font-medium text-slate-700">Email</label>
      <div>
        <input formControlName="email" type="email" max="100" class="input input-bordered w-full" placeholder="******@example.com">
        @if (parentForm.get('email')?.errors && parentForm.get('email')?.touched) {
          <div class="text-error text-xs mt-1">
            @if (parentForm.get('email')?.errors?.['email']) { Please enter a valid email address. }
            @if (parentForm.get('email')?.errors?.['maxlength']) { Email must not exceed 100 characters. }
          </div>
        }
      </div>
    </div>

    <div class="grid grid-cols-[220px_1fr] items-center gap-4">
      <label class="text-sm font-medium text-slate-700">Mobile No.</label>
      <div>
        <input formControlName="mobile_no" type="text" max="15" min="10" class="input input-bordered w-full" placeholder="+91 **********">
        @if (parentForm.get('mobile_no')?.errors && parentForm.get('mobile_no')?.touched) {
          <div class="text-error text-xs mt-1">
            {{ getFieldError(parentForm.get('mobile_no'), 'mobile_no') }}
          </div>
        }
      </div>
    </div>

    <div class="grid grid-cols-[220px_1fr] items-center gap-4">
      <label class="text-sm font-medium text-slate-700">Relation with Client</label>
      <div>
        <input formControlName="relation_with_client" type="text" max="100" class="input input-bordered w-full" placeholder="Enter relation with client">
        @if (parentForm.get('relation_with_client')?.errors && parentForm.get('relation_with_client')?.touched) {
          <div class="text-error text-xs mt-1">
            {{ getFieldError(parentForm.get('relation_with_client'), 'relation_with_client') }}
          </div>
        }
      </div>
    </div>
  </div>

  <div>
    <h3 class="text-sm font-semibold text-slate-700 underline underline-offset-4">Occupational Details</h3>
    <div class="mt-4 space-y-4">
      <div class="grid grid-cols-[220px_1fr] items-center gap-4">
        <label class="text-sm font-medium text-slate-700">Company</label>
        <div>
          <input formControlName="company" max="200" type="text" class="input input-bordered w-full" placeholder="Enter company name">
          @if (parentForm.get('company')?.errors && parentForm.get('company')?.touched) {
            <div class="text-error text-xs mt-1">
              {{ getFieldError(parentForm.get('company'), 'company') }}
            </div>
          }
        </div>
      </div>
      <div class="grid grid-cols-[220px_1fr] items-center gap-4">
        <label class="text-sm font-medium text-slate-700">Designation</label>
        <div>
          <input formControlName="designation" max="100" type="text" class="input input-bordered w-full" placeholder="Enter designation">
          @if (parentForm.get('designation')?.errors && parentForm.get('designation')?.touched) {
            <div class="text-error text-xs mt-1">
              {{ getFieldError(parentForm.get('designation'), 'designation') }}
            </div>
          }
        </div>
      </div>
      <div class="grid grid-cols-[220px_1fr] items-center gap-4">
        <label class="text-sm font-medium text-slate-700">Location</label>
        <div>
          <input formControlName="location" max="500" type="text" class="input input-bordered w-full" placeholder="Enter location">
          @if (parentForm.get('location')?.errors && parentForm.get('location')?.touched) {
            <div class="text-error text-xs mt-1">
              {{ getFieldError(parentForm.get('location'), 'location') }}
            </div>
          }
        </div>
      </div>
      
    </div>
  </div>

  <div class="flex justify-end pt-4">
    <button type="submit" class="btn btn-primary" [disabled]="isSaving">
      {{isSaving ? 'Updating...' : guardianId ? 'Update Guardian' : 'Create Guardian' }}
    </button>
  </div>
</form>
